import type { LoadWhopElements } from "./util";
import { initWhopElements, loadScript } from "./util";

export const loadWhopElements: LoadWhopElements = async (...args) => {
	const maybeWhopElements = await loadScript();

	return initWhopElements(maybeWhopElements, args);
};
